import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive.ts";

import ThemeBtn from "../Common/ThemeBtn.tsx";
import ThemeContext from "../context";
import useGetRedirect from "./hooks/useGetRedirect.tsx";

// ----------------------------------------------------------------------

export const TransfersSuccessStep = () => {
	const { theme } = useContext(ThemeContext);

	const { translate } = useLocales();
	const isMobile = useResponsive("down", "sm");
	const isDownMd = useResponsive("down", "md");

	const { onClickRedirect } = useGetRedirect();

	return (
		<Stack
			width={isDownMd ? "auto" : 800}
			height={isMobile ? "auto" : 500}
			alignItems={"center"}
			justifyContent={"center"}
			gap={1}
		>
			<Typography variant='h3' color={theme?.colors.primaryText}>
				{translate("transfers.success")}
			</Typography>
			<Typography variant='body1' color={theme?.colors.primaryText}>
				{translate("transfers.success_des_1")}
			</Typography>
			<Typography
				variant='body2'
				textAlign={"center"}
				color={theme?.colors.primaryText}
				mt={1}
				maxWidth={500}
			>
				{translate("transfers.success_des_2")}
			</Typography>
			<ThemeBtn
				title={translate("transfers.accept_button")}
				onClick={onClickRedirect}
				sx={{ mt: 4, minWidth: 150 }}
			/>
		</Stack>
	);
};

export default TransfersSuccessStep;
